import React from 'react';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';

import RegisterPage from '../containers/register';
import BeforeContinue from '../containers/login/before-continue';
import DataTreatment from '../containers/login/data-treatment';
import {ExistingUser, MinorUser} from '../containers/register/errors';
import InsuranceInYourHands from '../containers/login/insurance-in-your-hands';
import Homepage from '../containers/homepage';
import RegisterCompleted from '../containers/register/register-completed';
import ReimbursementHistory from '../containers/reimbursements/reimbursement-history';
import ReimbursementRequest from '../containers/reimbursements/reimbursement-request';
import MyData from '../containers/my-data';
import ForgetPassword from '../containers/login/forgot-password';
import ChangePassword from '../containers/login/change-password/index';
import ForgotEmail from '../containers/login/forgot-email';
import Profile from './../containers/profile/index';
import UtilizationHistory from '../containers/utilization';
import PreAuthorizationRequest from './../containers/pre-authorizations/components/pre-authorization-request/index';
import PreAuthorizations from '../containers/pre-authorizations';
import PreAuthorizationRequestSucess from '../containers/pre-authorizations/components/pre-authorization-request-sucess';
import PreAuthorizationProcedure from './../containers/pre-authorizations/components/pre-authorization-procedure/index';
import TalkWithUs from '../containers/talk-with-us';
import IrsDeclaration from './../containers/irs-declaration/index';
import ReimbursementSuccess from './../containers/reimbursements/reimbursement-request/success-screen/index';
import WantToRegister from '../containers/login/forgot-password/want-to-register';
import {functionalitiesAliasMap, strings} from './strings';
import Coverages from '../containers/coverages';
import MyServices from '../containers/services';
import Permissions from '../containers/permissions';
import TermsUpdate from '../containers/login/terms-update';
import Faqs from './../containers/faqs/index';
import Callback from '../components/auth/callback';
import Logout from '../components/auth/logout';
import LogoutCallback from '../components/auth/logout-callback';
import SilentRenew from '../components/auth/silent-renew';

import AuthLoadingPage from '../containers/auth-loading-page/AuthLoadingPage';
import FeatureToggleMedicalNetwork from '../containers/medical-network/FeatureToggleMedicalNetwork';
import Appointments from '../containers/appointments';
import ScheduleAppointment from '../containers/appointments/components/schedule-appointments/ScheduleAppointment';
import PersonalInfoConfirmation from '../containers/personal-info-confirmation';
import RegisterPageCMD from '../containers/registerCMD/RegisterPageCMD';
import RedirectApp from '../containers/redirect-app/RedirectApp';
import RedirectApp2 from '../containers/redirect-app/RedirectApp2';
import ProtectedRoute from '../routers/ProtectedRoute';
import PublicRoute from '../routers/PublicRoute';

function Routes() {
  return (
    <Router>
      <Switch>
        <Route exact path="/signin-oidc" component={Callback} />
        <Route exact path="/logout" component={Logout} />
        <Route path="/logout-callback" component={LogoutCallback} />
        <Route exact path="/silentrenew" component={SilentRenew} />
        <ProtectedRoute exact path="/" component={AuthLoadingPage} />
        <Route exact path="/callback" component={AuthLoadingPage} />
        (
        <PublicRoute
          path="/registo"
          component={RegisterPage}
          functionality={functionalitiesAliasMap.register}
        />
        ) (
        <PublicRoute
          path="/registoCMD"
          component={RegisterPageCMD}
          functionality={functionalitiesAliasMap.registoCMD}
        />
        ) (
        <PublicRoute
          exact
          path="/utilizador-menor"
          component={MinorUser}
          functionality={functionalitiesAliasMap.register}
        />
        ) (
        <PublicRoute
          exact
          path="/utilizador-existente"
          component={ExistingUser}
          functionality={functionalitiesAliasMap.register}
        />
        ) (
        <PublicRoute
          exact
          path="/registo-completo"
          component={RegisterCompleted}
          functionality={functionalitiesAliasMap.register}
        />
        ) (
        <PublicRoute
          exact
          path="/recuperar-email"
          component={ForgotEmail}
          functionality={functionalitiesAliasMap.register}
        />
        ) (
        <PublicRoute
          path="/recuperar-palavra-passe"
          component={ForgetPassword}
          functionality={functionalitiesAliasMap.register}
        />
        ) (
        <PublicRoute
          exact
          path="/deseja-registar"
          component={WantToRegister}
          functionality={functionalitiesAliasMap.register}
        />
        ) (
        <PublicRoute
          exact
          path="/alterar-password"
          component={ChangePassword}
          functionality={functionalitiesAliasMap.register}
        />
        ) (<Route exact path="/redirect-app" component={RedirectApp} />) (
        <Route exact path="/redirect-app2" component={RedirectApp2} />)
        <ProtectedRoute exact path="/inicio" component={Homepage} />
        <ProtectedRoute
          exact
          path="/politica-marketing"
          component={BeforeContinue}
        />
        <ProtectedRoute
          exact
          path="/atualizar-termos"
          component={TermsUpdate}
        />
        <ProtectedRoute
          exact
          path="/tratamento-dados"
          component={DataTreatment}
        />
        <ProtectedRoute
          exact
          path="/informacao-seguro"
          component={InsuranceInYourHands}
        />
        <ProtectedRoute
          exact
          path="/historico-utilizacao"
          component={UtilizationHistory}
        />
        <ProtectedRoute
          exact
          path="/meus-servicos"
          component={MyServices}
          functionality={functionalitiesAliasMap.services}
        />
        <ProtectedRoute
          exact
          path="/historico-reembolsos"
          component={ReimbursementHistory}
          functionality={functionalitiesAliasMap.refund}
        />
        <ProtectedRoute
          exact
          path="/historico-reembolsos/pedido-reembolso"
          component={ReimbursementRequest}
          functionality={functionalitiesAliasMap.createRefund}
        />
        <ProtectedRoute
          exact
          path="/meus-dados"
          component={MyData}
          functionality={functionalitiesAliasMap.myData}
        />
        <ProtectedRoute
          exact
          path="/historico-utilizacao"
          component={UtilizationHistory}
          functionality={functionalitiesAliasMap.utilization}
        />
        <ProtectedRoute
          exact
          path="/meu-perfil"
          component={Profile}
          functionality={functionalitiesAliasMap.myProfile}
        />
        <ProtectedRoute
          exact
          path="/pre-autorizacoes"
          component={PreAuthorizations}
          functionality={functionalitiesAliasMap.authorization}
        />
        {/* Verificar esta funcionalidade */}
        <ProtectedRoute
          exact
          path="/pre-autorizacoes/pedido-pre-autorizacao"
          component={PreAuthorizationRequest}
          functionality={functionalitiesAliasMap.authorization}
        />
        {/* Verificar esta funcionalidade */}
        <ProtectedRoute
          exact
          path="/pre-autorizacoes/pedido-enviado"
          component={PreAuthorizationRequestSucess}
          functionality={functionalitiesAliasMap.authorization}
        />
        <ProtectedRoute
          exact
          path="/historico-reembolsos/pedido-enviado"
          component={ReimbursementSuccess}
          functionality={functionalitiesAliasMap.createRefund}
        />
        <ProtectedRoute
          exact
          path="/pre-autorizacoes/procedimento-pre-autorizacao"
          component={PreAuthorizationProcedure}
          functionality={functionalitiesAliasMap.authorization}
        />
        <ProtectedRoute
          exact
          path="/fale-connosco"
          component={TalkWithUs}
          functionality={functionalitiesAliasMap.talkWithUs}
        />
        <ProtectedRoute
          exact
          path="/declaracao-irs"
          component={IrsDeclaration}
          functionality={functionalitiesAliasMap.irs}
        />
        <ProtectedRoute
          exact
          path="/minhas-coberturas"
          component={Coverages}
          functionality={functionalitiesAliasMap.coverages}
        />
        <ProtectedRoute
          exact
          path="/permissoes"
          component={Permissions}
          functionality={functionalitiesAliasMap.permissions}
        />
        <ProtectedRoute
          exact
          path="/perguntas-frequentes"
          component={Faqs}
          functionality={functionalitiesAliasMap.faq}
        />
        <ProtectedRoute
          exact
          path="/network"
          component={FeatureToggleMedicalNetwork}
          functionality={functionalitiesAliasMap.menuNetwork}
        />
        <ProtectedRoute
          exact
          path="/consultas-online"
          component={Appointments}
          functionality={functionalitiesAliasMap.appointments}
        />
        <ProtectedRoute
          exact
          path="/consultas-online/marcar-consulta"
          component={ScheduleAppointment}
          functionality={functionalitiesAliasMap.appointments}
        />
        <ProtectedRoute
          exact
          path="/confirmar-dados-pessoais"
          component={PersonalInfoConfirmation}
          functionality={functionalitiesAliasMap.personalInfoConfirmation}
        />
        <ProtectedRoute component={Homepage} />
      </Switch>
    </Router>
  );
}

export default Routes;
